module.exports = __webpack_public_path__ + "static/media/SimpleBadOptimized.b86d5605.jp2";